import { accessoryCategories } from 'data/constants';
import type { AccessoryCategoryType, AccessoryProductType } from 'data/types';
import type { CondenserAccessorySelectionType } from 'utils/condenser-accessory-selection-types';

const categoryForAccessory = (
  accessory: AccessoryProductType
): AccessoryCategoryType | undefined =>
  Object.keys(accessoryCategories).find((key) =>
    accessoryCategories[key as AccessoryCategoryType]?.includes(accessory.type)
  ) as AccessoryCategoryType | undefined;

export const applyAccessoryQuantityToCondenser = (
  condenser: CondenserAccessorySelectionType,
  accessory: AccessoryProductType,
  quantity: number
): void => {
  /* eslint-disable no-param-reassign */
  if (quantity > 0) {
    condenser.noAccessoriesNeeded = false;
  }

  const accessoryIndex = condenser.selectedAccessories.findIndex(
    (selected) => selected.productId === accessory.productId
  );
  if (accessoryIndex !== -1) {
    if (quantity > 0) {
      condenser.selectedAccessories[accessoryIndex].quantity = quantity;
    } else {
      condenser.selectedAccessories.splice(accessoryIndex, 1);
    }
  } else if (quantity > 0) {
    condenser.selectedAccessories.push({
      ...accessory,
      quantity
    });
  }

  const category = categoryForAccessory(accessory);
  if (!category) {
    return;
  }

  condenser.accessoriesCompleted = condenser.accessoriesCompleted.filter(
    (completed) => completed !== category
  );
  const categoryStillSelected = condenser.selectedAccessories.some((selected) =>
    accessoryCategories[category]?.includes(selected.type)
  );
  if (categoryStillSelected) {
    condenser.accessoriesCompleted.push(category);
    condenser.accessoriesNotNeeded = condenser.accessoriesNotNeeded.filter(
      (notNeeded) => notNeeded !== category
    );
  }
  /* eslint-enable no-param-reassign */
};
